export default __webpack_public_path__ + "static/media/stats.639c23bd.svg";